import React, { Component } from 'react'
import ReactDOM from 'react-dom'

const buttonRoots = document.querySelectorAll('.nav-search')

export default class ButtonPortal extends React.Component {
  constructor(props) {
    super(props);
    this.elements = [].map.call(buttonRoots, (button) => {
      return document.createElement('div')
    })
  }

  componentDidMount() {
    buttonRoots.forEach((button, index) => {
      button.appendChild(this.elements[index])
    })
  }

  componentWillUnmount() {
    buttonRoots.forEach((button, index) => {
      button.removeChild(this.elements[index])
    })
  }

  render() {
    return this.elements.map((element) => {
      return ReactDOM.createPortal(
        this.props.children,
        element,
      )
    })
  }
}